export default __webpack_public_path__ + "static/media/Group39711.4e5efe63.png";